/**
 * Stamp VWO assignments onto the Shopify cart (hidden cart attribute).
 * Cookies:
 * - A/B: _vis_opt_exp_{campaignId}_combi={combinationId}
 * - Split URL: _vis_opt_exp_{campaignId}_split={combinationId}:{url}
 */
(function () {
  var ATTR = '_vwo_experiments';
  var lastStamped = '';
  var inflight = null;

  function readVwoExperimentTokens() {
    var cookie = document.cookie || '';
    var re = /(?:^|;\s*)_vis_opt_exp_(\d+)_(combi|split)=([^;]*)/g;
    var byCampaign = {};
    var match;
    while ((match = re.exec(cookie))) {
      var comb = '';
      try {
        comb = decodeURIComponent(match[3] || '');
      } catch (e) {
        comb = String(match[3] || '');
      }
      comb = String(comb).trim().split(/[^\d]/)[0] || '';
      if (!match[1] || !comb) continue;
      if (!byCampaign[match[1]] || match[2] === 'combi') byCampaign[match[1]] = match[1] + ':' + comb;
    }
    return Object.keys(byCampaign).map(function (id) { return byCampaign[id]; }).sort().join(',');
  }

  function stampVwoExperiments() {
    var value = readVwoExperimentTokens();
    if (!value || value === lastStamped) return Promise.resolve(value);
    if (inflight) return inflight;
    inflight = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { _vwo_experiments: value } })
    })
      .then(function (res) {
        if (res.ok) lastStamped = value;
        return value;
      })
      .catch(function () {
        return value;
      })
      .finally(function () {
        inflight = null;
      });
    return inflight;
  }

  window.bzReadVwoExperiments = readVwoExperimentTokens;
  window.bzStampVwoExperiments = stampVwoExperiments;

  function boot() {
    stampVwoExperiments();
    setTimeout(stampVwoExperiments, 1000);
    setTimeout(stampVwoExperiments, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('pageshow', function () {
    stampVwoExperiments();
  });
})();
